// src/NotFound.js
import React from 'react';
import { Link } from 'react-router-dom';

function NotFound() {
  return (
    <div className="container text-center mt-5">
      <h1 className="display-4 text-danger">404</h1>
      <p className="lead">ไม่พบหน้าที่คุณค้นหา</p>
      <Link to="/" className="btn btn-primary">กลับหน้าหลัก</Link>
    </div>
  );
}

export default NotFound;
